import React from 'react';
import { isMobile } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { MobileResultWrapper } from '../mobileResultWrapper';
import { WebResultWrapper } from '../webResultWrapper';
import { gameStore } from '../../store/gameStore';
import { FishByType } from '../../core/constants/fishImagesArray';

const GameResultItemWrapper = observer(() => {
  const { reportResult, currentRound } = gameStore;

  return (
    <div className='gameLeftMainHolder'>
      {reportResult.map((el, index) => {
        const fishResult = reportResult[index];
        const parsedResultType =
          fishResult?.resultType > 9 && fishResult?.resultType < 15
            ? fishResult?.resultType - 1
            : fishResult?.resultType > 15
            ? fishResult?.resultType - 2
            : fishResult?.resultType;

        const key = `${reportResult.length - index}${currentRound?.roundId}_${parsedResultType}_${
          fishResult?.odd
        }`;

        return (
          <div className={`gameFishHolder ${fishResult?.animation ? 'showFish' : ''}`} key={key}>
            <div className='gameFishContainer'>
              <img className='gameFish' src={FishByType[parsedResultType]} alt='fish' />
            </div>
            <div className='gameFishMultiplierContainer'>
              <span className='gameFishMultiplierTxt'>x{fishResult?.odd}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
});
export const CurrentRoundResults = () => {
  return isMobile() ? (
    <MobileResultWrapper>
      <GameResultItemWrapper />
    </MobileResultWrapper>
  ) : (
    <WebResultWrapper>
      <GameResultItemWrapper />
    </WebResultWrapper>
  );
};
